import { testPaths } from "./../../constants/route-paths";

export const Breadcrumb = [
  { text: "Home", href: "/" },
  { text: "request status", href: testPaths.REQEST_STATUS },
  { text: "request detail", href: testPaths.REQUEST_DETAIL },
];
